import { when as mobxWhen, Lambda, IReactionDisposer } from 'mobx';

type Predicate = () => boolean;

const setWhen = (
  predicate: Predicate,
  effect: Lambda,
  disposers: Set<IReactionDisposer>,
): void => {
  const setWhenNot = () => {
    const disposer = mobxWhen(
      () => !predicate(),
      () => {
        disposers.delete(disposer); // since mobx 'When' auto-disposes when it's effect executes */
        setWhen(predicate, effect, disposers);
      },
    );
    disposers.add(disposer);
  };

  const disposer = mobxWhen(predicate, () => {
    disposers.delete(disposer); // since mobx 'When' auto-disposes when it's effect executes */
    setWhenNot();
    effect();
  });
  disposers.add(disposer);
};

export function whenever(predicate: Predicate, effect: Lambda) {
  /* 'whenever' is a primitive which allows us to do some side effect 
   such as a query, subscription or mutations *whenever* something becomes true.
   
   'When' is implemented as a small wrapper around the Mobx 'when' function.

   It's perfectly sensible to run an Action in the effect function to modify mobx state.
   Sometime it might make sense to set the predicate value to false then - creating a 'resetting state'
   */
  const disposers = new Set([]);
  setWhen(predicate, effect, disposers);
  return () => {
    disposers.forEach(disposer => disposer()); // clear disposers after running disposers?
    disposers.clear();
  };
}
